var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.teamSubscriptions,
      expression: "loading.teamSubscriptions"
    }],
    attrs: {
      "title": "subscriptions"
    }
  }, [_c('h4', [_vm._v("Stripe")]), _c('Table', {
    attrs: {
      "items": _vm.stripe,
      "columns": _vm.columns,
      "links": _vm.stripeLinks,
      "filterProp": "plan_name"
    }
  }), _c('h4', [_vm._v("PayPal")]), _c('Table', {
    attrs: {
      "items": _vm.paypal,
      "columns": _vm.columns,
      "links": _vm.paypalLinks,
      "filterProp": "plan_name"
    }
  }), _vm.stiggSubsctiption ? _c('div', [_c('h4', [_vm._v("Stigg")]), _c('json-viewer', {
    attrs: {
      "value": _vm.stiggSubsctiption
    }
  })], 1) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }